<form id="locationForm" name="locationForm" role="form" *ngIf="serviceFormGroup" [formGroup]="serviceFormGroup">
  <div class="formgrid grid">
    <div class="field col-12" *ngIf="isNew">
      <label for="companyName">Service identifier <span class="text-red-500">*</span></label>
      <input
        pInputText
        id="companyName"
        name="companyName"
        type="text"
        formControlName="companyName"
        [ngClass]="{ 'w-full': true, 'text-sm': true, 'ng-invalid': isControlInvalid('companyName') }"
        [required]="true"/>
      <ul class="error-form-text" *ngIf="isControlInvalid('companyName')">
        <li>This field is required</li>
      </ul>
    </div>
    <div class="field col-12">
      <label for="provider">Provider <span class="text-red-500">*</span></label>
      <input
        pInputText
        id="provider"
        name="provider"
        type="text"
        formControlName="provider"
        [ngClass]="{ 'w-full':true,'text-sm': true, 'ng-invalid': isControlInvalid('provider') }"
        [required]="true"/>
      <ul
        class="error-form-text"
        *ngIf="isControlInvalid('provider')">
        <li>This field is required</li>
      </ul>
    </div>
    <div class="field col-12">
      <label for="serviceType">Service type <span class="text-red-500">*</span></label>
      <p-dropdown
        inputId="serviceType"
        name="serviceType"
        [options]="serviceTypeValues"
        formControlName="serviceType"
        optionLabel="label"
        optionValue="value"
        dataKey="value"
        placeholder="Select a type"
        [style]="{ width: '100%' }"
        [ngClass]="{ 'text-sm': true }"
        (onChange)="onServiceTypeChange($event)"/>
    </div>
  </div>
</form>
<div class="p-dialog-footer">
  <button pButton type="button" label="Save" icon="pi pi-save" (click)="save()"
          [disabled]="serviceFormGroup.invalid"></button>
  <button pButton type="button" label="Cancel" icon="pi pi-times" (click)="cancel()"></button>
</div>
